module.exports = __webpack_public_path__ + "static/media/isologotipo_general_colores.4bf587aa.png";